import { useEffect, useRef } from 'react'

import { useFeatureSwitch } from '@marketplace-web/shared/feature-switches'
import { useLocation } from '@marketplace-web/shared/browser'
import { getCatalogSearchScope } from 'data/api/get-catalog-search-scope'
import { useCatalogContext } from 'pages/Catalog/CatalogProvider'
import { getSearchStartData } from '@marketplace-web/domain/search'

import useFetchDynamicFilters from './useFetchDynamicFilters'

const useHandleCatalogSearchTextChange = () => {
  const {
    state: {
      dynamicFilters: { selectedDynamicFilters },
      general: { filtersChangeCount },
    },
  } = useCatalogContext()
  const { searchParams } = useLocation()

  const fetchDynamicFilters = useFetchDynamicFilters()

  const filtersChangeCountRef = useRef(filtersChangeCount)
  filtersChangeCountRef.current = filtersChangeCount

  const catalogIdRef = useRef(searchParams.catalog?.[0])
  catalogIdRef.current = searchParams.catalog?.[0]

  const selectedDynamicFiltersRef = useRef(selectedDynamicFilters)
  selectedDynamicFiltersRef.current = selectedDynamicFilters

  const searchText = searchParams.search_text ? String(searchParams.search_text) : undefined

  const searchScopeEnabled = useFeatureSwitch('scoped_search_mvp_enabled')
  const searchScopeRequestVersion = useRef(0)

  useEffect(() => {
    ;(async () => {
      if (filtersChangeCountRef.current < 1) return

      let newCatalogIds: Array<number> | undefined | null = null

      const { searchStartId, searchStartType } = getSearchStartData()
      if (searchStartId && searchStartType && searchScopeEnabled && searchText) {
        searchScopeRequestVersion.current += 1
        const version = searchScopeRequestVersion.current

        const searchScope = await getCatalogSearchScope({
          searchText,
          catalogId: catalogIdRef.current,
          search_start_id: searchStartId,
          search_start_type: searchStartType,
        })

        if (!('errors' in searchScope) && version === searchScopeRequestVersion.current) {
          if (searchScope.catalog_id != null) {
            newCatalogIds = [Number(searchScope.catalog_id)]
          }
        }
      }

      fetchDynamicFilters({
        selectedDynamicFilters: selectedDynamicFiltersRef.current,
        isSearchTextOnly: true,
        selectedFilters: newCatalogIds
          ? {
              catalogIds: newCatalogIds,
            }
          : undefined,
      })
    })()
  }, [fetchDynamicFilters, searchScopeEnabled, searchText])
}

export default useHandleCatalogSearchTextChange
